import { render, staticRenderFns } from "./staff-bonuses.vue?vue&type=template&id=1e72c329&"
import script from "./staff-bonuses.vue?vue&type=script&lang=js&"
export * from "./staff-bonuses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports